// extracted by mini-css-extract-plugin
export default {"menuBlock":"LG-z","title":"MG-z","nav":"NG-z","flexCell":"OG-z","facetLink":"PG-z"};